/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface PaymentProviderFundTransferInputDto { 
    fromAccountCode?: string | null;
    fromAccountName?: string | null;
    toAccountCode?: string | null;
    toAccountName?: string | null;
    tenantid?: number;
    amount?: number;
}

